module.exports = __webpack_public_path__ + "img/ic_cec_logo_normal.ddf1be4.png";